import { Parser } from '~/api';
import { ServerTemplateSchedule } from '~/api/models';
import { useModelsStore } from '~/stores';
import RequestService from './request';

interface CreateScheduleRequest {
    name: string;
    cron_minute: string;
    cron_hour: string;
    cron_day_of_week: string;
    cron_day_of_month: string;
    is_active: boolean;
    is_managed: boolean;
    user_can_toggle: boolean;
    spread_window: number | null;
}

interface UpdateScheduleRequest extends CreateScheduleRequest {
    id: string;
}

interface DeleteScheduleRequest {
    id: string;
}

const refreshTemplate = (): void => {
    useModelsStore().refreshModel('serverTemplate');
};

class ServerTemplateSchedulesService {
    create(data: CreateScheduleRequest): Promise<ServerTemplateSchedule> {
        return RequestService.post('/server-templates/:serverTemplate/schedules', data)
            .then(Parser.parse)
            .then((schedule: ServerTemplateSchedule) => {
                refreshTemplate();

                return schedule;
            });
    }

    update(data: UpdateScheduleRequest): Promise<ServerTemplateSchedule> {
        return RequestService.put(`/server-templates/:serverTemplate/schedules/${data.id}`, data)
            .then(Parser.parse)
            .then((schedule: ServerTemplateSchedule) => {
                refreshTemplate();

                return schedule;
            });
    }

    delete(data: DeleteScheduleRequest): Promise<void> {
        return RequestService.delete(`/server-templates/:serverTemplate/schedules/${data.id}`).then(() => {
            refreshTemplate();
        });
    }
}

export default new ServerTemplateSchedulesService();
